import { render, staticRenderFns } from "./InternalOrderWithoutConfigurationPopup.vue?vue&type=template&id=5161b46e&scoped=true"
import script from "./InternalOrderWithoutConfigurationPopup.vue?vue&type=script&lang=ts"
export * from "./InternalOrderWithoutConfigurationPopup.vue?vue&type=script&lang=ts"
import style0 from "./InternalOrderWithoutConfigurationPopup.vue?vue&type=style&index=0&id=5161b46e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161b46e",
  null
  
)

export default component.exports